@if (activeSectionRoute$ | async) {}
<a
  class="icon-btn no-underline"
  (click)="settingsMenu.toggle($event)"
  [ngClass]="{ 'icon-active': isActive() }"
>
  <em class="ph ph-gear-six"></em>
</a>
<p-menu
  #settingsMenu
  [model]="settingMenuItems()"
  [popup]="true"
  appendTo="body"
/>
